import { defineMessages } from 'react-intl';

export default defineMessages({
  genericError: {
    id: 'roomi.input.generic.error',
    defaultMessage: 'Missing required field'
  }
});
